import React from 'react';
import { BRAND, isBrandOV, isMarketGB } from '../../../constants/main';
import { TitleWithBenefitsStyledOVGB } from '@components/v2/TitleWithBenefits/OV/GB/TitleWithBenefitsStyled.OVGB';
import { TitleWithBenefitsStyledOV } from '@components/v2/TitleWithBenefits/OV/TitleWithBenefitsStyled.OV';
import { TitleWithBenefitsStyledAC } from '@components/v2/TitleWithBenefits/AC/TitleWithBenefitsStyled.AC';
import { TitleWithBenefitsStyledAP } from '@components/v2/TitleWithBenefits/AP/TitleWithBenefitsStyled.AP';
import { TitleWithBenefitsStyledDS } from '@components/v2/TitleWithBenefits/DS/TitleWithBenefitsStyled.DS';
import { TitleWithBenefitsStyled } from '@components/v2/TitleWithBenefits/TitleWithBenefitsStyled';
import { SC } from '../../../styles/theme';

export interface CarNameProps extends SC {
    engineInfo?: boolean;
    pipes?: boolean;
    boldInverting?: boolean;
    carDetails?: any;
    showLeadTime?: boolean;
    characteristicsOpen?: boolean;
    withBenefits?: boolean;
    onlyBenefits?: boolean;
    onlyTitle?: boolean;
    isSpeckPackTitleBold?: boolean;
    isBasket?: boolean;
    onClick?: () => void;
}

const TitleWithBenefits = (props: CarNameProps) => {
    if (isBrandOV)
        return isMarketGB ? <TitleWithBenefitsStyledOVGB {...props} /> : <TitleWithBenefitsStyledOV {...props} />;
    if (BRAND === 'AC') return <TitleWithBenefitsStyledAC {...props} />;
    if (BRAND === 'AP') return <TitleWithBenefitsStyledAP {...props} />;
    if (BRAND === 'DS') return <TitleWithBenefitsStyledDS {...props} />;
    return <TitleWithBenefitsStyled {...props} />;
};

export default TitleWithBenefits;
